export const camelToSnakeCase = (str) => {
    return str
        .trim()
        .normalize('NFD') // split letters + accents
        .replace(/\p{Diacritic}/gu, '') // drop the accents
        .replace(/[^a-zA-Z0-9]/g, '') // keep only alphanumeric characters
        .replace(/([a-z0-9])([A-Z])/g, '$1_$2') // insert underscore before a transition from lower-or-digit → upper
        .replace(/([A-Z]+)([A-Z][a-z0-9]+)/g, '$1_$2') // insert underscore before a transition from acronym → normal word (e.g. "XMLHttp" → "XML_Http")
        .toLowerCase();
};
//# sourceMappingURL=case.js.map